import { Box, Button, MenuItem, Paper, Select, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useCoinUnitPrices } from '../../../hooks/queries/useCoinUnitPrice';
import { useQueryStringState } from '../../../hooks/useQueryStringState';
import useSnackbar from '../../../hooks/useSnackbar';
import { CoinUnitPriceType, downloadCoinUnitPrices } from '../../../services/api/CoinUnitPrice';
import { downloadCSVFromText } from '../../../services/utils';
import CoinUnitPriceTable from './CoinUnitPriceTable';

const CurrentYear = new Date().getFullYear();

const CoinUnitPriceFinalizedView = (): JSX.Element => {
  const snackbar = useSnackbar();

  const [year, setYear] = useQueryStringState<number>('year', CurrentYear);
  const { data: finalizedCoinUnitPricesFromQuery = [] } = useCoinUnitPrices(CoinUnitPriceType.Finalized, year);

  const yearMenuItems = useMemo(() => {
    const items: JSX.Element[] = [];
    for (let y = CurrentYear; y >= 2021; y--) {
      items.push(
        <MenuItem value={y} key={y}>
          {y}
        </MenuItem>,
      );
    }

    return items;
  }, []);

  const handleDownloadClick = async () => {
    try {
      const { status, data } = await downloadCoinUnitPrices(CoinUnitPriceType.Finalized, year);
      if (status === 200) {
        downloadCSVFromText(data, `CoinUnitPrice_${year}`);
      } else {
        throw new Error('Unable to download a CSV file.');
      }
    } catch (e) {
      snackbar.error(e);
    }
  };

  return (
    <Box>
      <Typography variant="h6">Finalized Coin Unit Price History</Typography>
      <Box display="flex" justifyContent="space-between" marginTop="10px" marginBottom="21px">
        <Select value={year} onChange={e => setYear(Number(e.target.value))}>
          {yearMenuItems}
        </Select>
        <Button variant="outlined" size="small" color="primary" onClick={handleDownloadClick} style={{ marginTop: '2px' }}>
          Download CSV
        </Button>
      </Box>
      <Paper>
        <CoinUnitPriceTable type={CoinUnitPriceType.Finalized} coinUnitPrices={finalizedCoinUnitPricesFromQuery} />
      </Paper>
    </Box>
  );
};

export default CoinUnitPriceFinalizedView;
